import React from 'react';
import { connect } from 'react-redux';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import EquipmentLoader from '../loaders/EquipmentLoader';
import { dateTime } from '../../utils/parsing';
import EquipSingleLink from '../explore/EquipSingle/EquipSingleLink';

import './stale-points.css';

const StalePointsTable = ({ name, points, percentStale, timezone }) => (
  <>
    <Typography variant="h6">
      {name} Stale Points ({percentStale}%)
    </Typography>
    <div className="stale-points-wrapper">
      <Table className="stale-points">
        <TableHead>
          <TableRow>
            <TableCell>Name/Id</TableCell>
            <TableCell>Datasource Hash</TableCell>
            <TableCell>Last updated</TableCell>
            <TableCell>Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {points.map((p) => (
            <TableRow key={p.id}>
              <TableCell>
                <EquipSingleLink pointId={p.id} text={`${p.name} (id=${p.id})`} />
              </TableCell>
              <TableCell>{p.hash}</TableCell>
              <TableCell>{dateTime(p.lastUpdatedTs, timezone)}</TableCell>
              <TableCell>{p.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  </>
);

/**
 * A table of points in a building which haven't been updated recently
 */
const BuildingStalePoints = ({ building, hasIngest, stalePoints, percentStale }) =>
  !hasIngest ? null : (
    <>
      <EquipmentLoader buildingId={building.id} />
      {stalePoints?.length ? (
        <StalePointsTable
          points={stalePoints}
          name={building.name}
          timezone={building.timezone}
          percentStale={percentStale}
        />
      ) : null}
    </>
  );

export default connect((state, { building }) => {
  const {
    entities: {
      ingestStats: { latestTimestamps },
      points: { staleIdsByBuilding, byId },
    },
  } = state;
  const latestTimestamp = latestTimestamps[building.id];
  const stalePoints = (staleIdsByBuilding[building.id] || [])
    .map((id) => byId[id])
    .filter((p) => p != null);
  const percentStale = ((100 * stalePoints.length) / Math.max(building.pointCount, 1)).toFixed(1);
  return { hasIngest: latestTimestamp != null, stalePoints, percentStale };
})(BuildingStalePoints);
